import Svg from 'components/utilities/svg'

const HelpCircleIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Help Circle Icon</title>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 17h-2v-2h2v2zm2.07-7.75-.9.92A3.4 3.4 0 0 0 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8a4 4 0 1 1 8 0c0 .88-.36 1.68-.93 2.25z" />
  </Svg>
)

HelpCircleIcon.displayName = 'HelpCircle'

export default HelpCircleIcon
